import { ACTIONS } from "src/_config";
import { PromotionalBlock } from "src/_types/cms";

interface CmsState {
  blocks: PromotionalBlock[];
}

const initialState: CmsState = {
  blocks: [],
};

const cmsReducer = (state = initialState, action: any) => {
  //console.log(action.payload);
  switch (action.type) {
    case ACTIONS.CMS.GET_BLOCKS:
      return {
        ...state,
        blocks: action.payload.list || [],
      };
    default:
      return state;
  }
};

export default cmsReducer;
